<template lang="pug">
.v-banner.banner(v-if="data" :style="{backgroundImage: `url('${data.backgroundImage}')`, backgroundColor: data.backgroundColor}" :id="data?.id")
	.banner__content
		.banner__title(v-if="data.title" v-html="data.title")
		.banner__text(v-if="data.text" v-html="data.text")
		.banner__actions(v-if="data.actions || data.apps")
			v-action.banner__action.btn(v-for="action in data.actions" :action="action")
				template(#icon)
					img.btn__icon(v-if="action.icon" :src="action.icon")
			template(v-if="data.apps && !isTablet")
				v-action.banner__action.btn(v-for="app in data.apps" :action="app")
					template(#icon)
						img.btn__icon(v-if="app.icon" :src="app.icon")
			v-app-widget(v-if="isTablet" :button="data.widget.button")
	img.banner__image(v-if="data.image" :src="data.image.src" :alt="data.image.alt")
</template>

<script>

import sourceMixin from "../components/mixins/v-mixin-source.vue";
import isMobMixin from "./mixins/v-mixin-is-mob.vue";

export default {

	mixins: [
		sourceMixin,
		isMobMixin
	],

	data() {
		return {
			data: null
		}
	},

	methods: {
		dataSet(data) {
			this.data = data;
		}
	}
}

</script>